
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[...slug]",
      function () {
        return require("private-next-pages/articles/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[...slug]"])
      });
    }
  